import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "appStatus",
})
export class AppStatusPipe implements PipeTransform {
  transform(status: any, args?: any): any {
    let result = status;
    switch (status) {
      case "SystemInactive":
        result = "System Inactive";
      default:
        break;
    }
    return result;
  }
}
